import React, { useEffect, useState, useRef } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import Geocode from "react-geocode";
import GoogleMarkerIcon from '../../assets/images/google-marker-icon.svg';

const googleApiKey = process.env.REACT_APP_MAP_API_KEY || "AIzaSyDHXqdx1MvM1BXw20L-r39yZjuLPIVfOXI";
Geocode.setApiKey(googleApiKey);
Geocode.enableDebug();

const containerStyle = {
  width: "100%",
  height: "270px",
};

interface Position {
  lat: number;
  lng: number;
}

interface Props {
  center: Position;
  onReverse: (googleAddress:any,markerPosition:any) => void;
}

const DraggableMarkerMap: React.FC<Props> = ({ center,onReverse }) => {
  const [markerPosition, setMarkerPosition] = useState(center);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleApiKey,
  });

  
  const handleMarkerDrag = (event: google.maps.MapMouseEvent) => {
    setMarkerPosition({
      lat: event.latLng?event.latLng.lat():center.lat,
      lng: event.latLng?event.latLng.lng():center.lng,
    });
    
    getAddressFormMap();
  };


  const getAddressFormMap = () => {
    let newLat = markerPosition.lat,
        newLng = markerPosition.lng;
    
    Geocode.fromLatLng( newLat , newLng ).then(
      (response:any) => {
        const   addressArray =  response.results[0].address_components;
        console.log("response",response)


      // Filter out city, state, and ZIP code from address components
      const filteredAddressComponents = addressArray.filter(
        (component) =>
          !["locality", "administrative_area_level_1", "postal_code"].includes(
            component.types[0]
          )
      );

    // Filter out address components that we don't want in streetAddress
    const streetAddressComponents = filteredAddressComponents
    .filter(
      (component) =>
        [
          "street_number","route","neighborhood","political","sublocality"
        ].includes(component.types[0])
    )
    .map((component) => component.long_name);

  const streetAddress = streetAddressComponents.join(" ");


        
        const address = response.results[0].formatted_address,
             
              city = getCity( addressArray ),
              area = getArea( addressArray ),
              zipcode = getZipCode( addressArray ),
              state = getState( addressArray );

        let googleAddress = {
          address:address,
          streetAddress: streetAddress,
          addressArray:addressArray,
          city:city,
          area:area,
          zipcode:zipcode,
          state:state,
        }
        console.log("googleAddress",googleAddress)
        onReverse(googleAddress,markerPosition);        
      },
      (error:any) => {
        // console.error(error);
      }
    );
  };
  
  useEffect(() => {
      getAddressFormMap();
  }, [])
  const getCity = ( addressArray:any ) => {
    let city = '';
    for( let i = 0; i < addressArray.length; i++ ) {
      if ( addressArray[ i ].types[0] && 'administrative_area_level_2' === addressArray[ i ].types[0] ) {
        city = addressArray[ i ].long_name;
        return city;
      }
    }
  };

  
  const getArea = ( addressArray:any ) => {
    let area = '';
    for( let i = 0; i < addressArray.length; i++ ) {
      if ( addressArray[ i ].types[0]  ) {
        for ( let j = 0; j < addressArray[ i ].types.length; j++ ) {
          if ( 'sublocality_level_1' === addressArray[ i ].types[j] || 'locality' === addressArray[ i ].types[j] ) {
            area = addressArray[ i ].long_name;
            return area;
          }
        }
      }
    }
  };
  
  const getState = ( addressArray:any ) => {
    let state = '';
    for( let i = 0; i < addressArray.length; i++ ) {
      for( let i = 0; i < addressArray.length; i++ ) {
        if ( addressArray[ i ].types[0] && 'administrative_area_level_1' === addressArray[ i ].types[0] ) {
          state = addressArray[ i ].long_name;
          return state;
        }
      }
    }
  };

  const getZipCode = ( addressArray:any ) => {
    let state = '';
    for( let i = 0; i < addressArray.length; i++ ) {
      for( let i = 0; i < addressArray.length; i++ ) {
        if ( addressArray[ i ].types[0] && 'postal_code' === addressArray[ i ].types[0] ) {
          state = addressArray[ i ].long_name;
          return state;
        }
      }
    }
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={15}
      options={{
        draggable: true,
        zoomControl: false, 
        fullscreenControl: false, 
        disableDefaultUI: true
      }}
    >
      <Marker
        position={markerPosition}
        draggable={true}
        onDragEnd={handleMarkerDrag}
        icon={GoogleMarkerIcon}
      />
    </GoogleMap>
  ) : (
    <></>
  );
};

export default DraggableMarkerMap;
